<template>
  <div class="existing-materials-list">
    <div v-if="loading" class="text-center py-4">
      <b-spinner variant="danger" label="Cargando..."></b-spinner>
      <p class="mt-2 text-muted">Cargando materiales...</p>
    </div>

    <div v-else-if="materials.length === 0" class="empty-state">
      <p>No se encontraron materiales para esta asignatura y curso.</p>
    </div>

    <div v-else class="materials-grid">
      <div
        v-for="material in materials"
        :key="material.id"
        class="material-card"
        :class="{ selected: selectedMaterialId === material.id }"
        @click="selectMaterial(material)"
      >
        <div class="material-card-body">
          <div class="material-name">{{ material.name }}</div>
          <div v-if="material.duration" class="material-duration">
            {{ material.duration }} min
          </div>
        </div>
        <div class="material-card-footer">
          <span class="select-label">
            {{ selectedMaterialId === material.id ? '✓ Seleccionado' : 'Seleccionar' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customMaterialService from "@/services/customMaterialService";

export default {
  name: "ExistingMaterialsList",
  props: {
    context: {
      type: Object,
      required: true,
    },
    canWork: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      materials: [],
      loading: true,
      selectedMaterialId: null,
    };
  },
  computed: {
    school() {
      return this.$store.state.login.school;
    },
    subject() {
      const conv = this.$store.state.chatbot.conversation;
      return conv && conv.subject && conv.subject.answer
        ? conv.subject.answer
        : null;
    },
    grade() {
      const conv = this.$store.state.chatbot.conversation;
      return conv && conv.grade && conv.grade.answer
        ? conv.grade.answer
        : null;
    },
  },
  mounted() {
    this.fetchMaterials();
  },
  methods: {
    async fetchMaterials() {
      this.loading = true;
      try {
        const subjectCode = this.subject ? this.subject.enum_code : null;
        const gradeCode = this.grade ? this.grade.code : null;

        if (!subjectCode || !gradeCode) {
          this.materials = [];
          this.loading = false;
          return;
        }

        const response = await customMaterialService.getFilteredMaterials(
          this.school,
          subjectCode,
          gradeCode
        );
        this.materials = response.materials || [];
      } catch (error) {
        console.error("Error fetching materials:", error);
        this.materials = [];
      } finally {
        this.loading = false;
      }
    },
    selectMaterial(material) {
      this.selectedMaterialId = material.id;
      this.$store.commit("chatbot/updateMessage", {
        name: "existing_materials_list",
        key: "selectedMaterialId",
        value: material.id,
      });
      this.$store.commit("chatbot/updateMessage", {
        name: "existing_materials_list",
        key: "selectedMaterialName",
        value: material.name,
      });
      this.$store.commit("chatbot/updateMessage", {
        name: "existing_materials_list",
        key: "selectedMaterialPdf",
        value: material.pdf || null,
      });
      this.$emit("switch-continue-button", true);
    },
  },
};
</script>

<style scoped>
.existing-materials-list {
  padding: 10px 0;
}

.materials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 14px;
}

.material-card {
  border: 2px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.material-card:hover {
  border-color: #e84855;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(232, 72, 85, 0.1);
}

.material-card.selected {
  border-color: #e84855;
  background: rgba(232, 72, 85, 0.05);
  box-shadow: 0 6px 20px rgba(232, 72, 85, 0.15);
}

.material-card-body {
  margin-bottom: 10px;
}

.material-name {
  font-weight: 600;
  font-size: 15px;
  color: #1f2937;
  line-height: 1.3;
  margin-bottom: 6px;
}

.material-duration {
  font-size: 13px;
  color: #6b7280;
}

.material-card-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.pdf-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  color: #dc2626;
  cursor: pointer;
  transition: all 0.15s ease;
}

.pdf-btn:hover {
  background: #fee2e2;
  border-color: #fca5a5;
}

.delete-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
  color: #9ca3af;
  transition: all 0.15s ease;
}

.delete-btn:hover {
  background: #fef2f2;
  border-color: #fecaca;
  color: #dc2626;
}

.select-label {
  font-size: 13px;
  font-weight: 600;
  color: #e84855;
}

.material-card.selected .select-label {
  color: #b91c1c;
}

.empty-state {
  padding: 20px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
  background: #fafafa;
}
</style>
